<template>
  <div>
    <Validate v-if="dmr === null"></Validate>
    <div v-else>
      <v-container fluid>
        <v-toolbar dense class="mb-3 primary" dark>
          <div class="title">Total : {{ dmr.consumed_limit }}</div>
          <v-spacer></v-spacer>
          <div class="title">Remaining Limit : {{ dmr.remaining_limit }}</div>
        </v-toolbar>
        <v-layout row>
          <v-flex sm6 style="margin-right: 10px">
            <div>
              <v-toolbar dense>
                <v-toolbar-title>Beneficiary List</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items></v-toolbar-items>
              </v-toolbar>
              <v-card
                v-for="(item, i) in benifylist"
                :key="i"
                style="margin-top: 5px"
              >
                <v-card-title style="padding-bottom: 0px">
                  <div>
                    <div>Name: {{ item.beneficiary_name }}</div>
                    <div>Bank: {{ item.beneficiary_bank_name }}</div>
                    <div>Acc No: {{ item.beneficiary_account_no }}</div>
                    <div>IFSC Code: {{ item.ifsc_code }}</div>
                  </div>
                </v-card-title>
                <v-card-actions>
                  <v-btn
                    flat
                    color="success"
                    @click="
                      currentb = item;
                      transfer = true;
                    "
                    >Transfer</v-btn
                  >
                  <v-btn
                    flat
                    v-if="item.verification_status === 'NOT_VERIFIED'"
                    color="info"
                    @click="validate(item)"
                    >Validate</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat color="error" @click="remove(item)">remove</v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </v-flex>
          <v-flex sm6 style="margin-left: 10px">
            <v-toolbar dense>
              <v-toolbar-title>Add Beneficiary</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items></v-toolbar-items>
            </v-toolbar>
            <div>
              <v-text-field
                type="text"
                style="
                  width: 300px;
                  margin: 0 auto;
                  height: 60px;
                  margin-top: 20px;
                "
                label="Beneficiary Name"
                v-model="bname"
                solo
              />
              <v-text-field
                type="number"
                style="width: 300px; margin: 0 auto; height: 60px"
                label="Beneficiary Mobile"
                v-model="bmobile"
                solo
              />
              <v-text-field
                type="number"
                style="width: 300px; margin: 0 auto; height: 60px"
                label="Beneficiary Account Number"
                v-model="baccount"
                solo
              />
              <v-text-field
                type="text"
                style="width: 300px; margin: 0 auto; height: 60px"
                label="IFSC Code"
                v-model="bifsccode"
                solo
              />
              <v-autocomplete
                style="width: 300px; margin: 0 auto; height: 60px"
                :items="banklist"
                item-text="bank_name"
                item-value="bank_id"
                label="Bank Name"
                v-model="bbname"
                solo
              />
              <div style="width: 300px; margin: 0 auto; height: 60px">
                <v-btn
                  color="primary"
                  @click="addbeneficiary"
                  style="width: 300px; margin-left: 0px"
                  >Add Beneficiary</v-btn
                >
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-dialog v-model="transfer" persistent width="400">
      <v-card>
        <v-card-title>Transfer Money</v-card-title>
        <v-divider></v-divider>
        <v-card-title style="padding-bottom: 0px">
          <div style="margin-bottom: 10px">
            <div>Name: {{ currentb.beneficiary_name }}</div>
            <div>Bank: {{ currentb.beneficiary_bank_name }}</div>
            <div>Acc No: {{ currentb.beneficiary_account_no }}</div>
            <div>IFSC Code: {{ currentb.ifsc_code }}</div>
          </div>
        </v-card-title>
        <v-layout row wrap>
          <v-flex sm6>
            <v-radio-group style="margin-left: 20px" row v-model="type">
              <v-radio label="IMPS" value="imps"></v-radio>
              <v-radio label="NEFT" value="neft"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              type="number"
              style="height: 60px; width: 180px"
              label="Amount"
              v-model="amount"
              solo
            />
          </v-flex>
        </v-layout>
        <v-card-title>
          <div>
            <div style="color: red">{{ dmrmessage }}</div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn flat :disabled="loader" color="success" v-if="dmrmessage !== ''" @click="submit"
            >Confirm and pay</v-btn
          >
          <v-btn flat color="info" v-else @click="dmrcharge">Transfer</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="error"
            @click="
              transfer = false;
              currentb = {};
            "
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="otpcheck" persistent width="300" height="300">
      <v-card>
        <v-card-title>Enter OTP</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            type="number"
            style="width: 200px; margin: 0 auto; height: 60px"
            label="OTP"
            v-model="otp"
            solo
          />
          <v-btn
            color="primary"
            @click="verifyotp"
            style="width: 200px; margin-left: 35px"
            >Submit</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <Loader v-if="loader"></Loader>
  </div>
</template>
<script>
import Loader from "../components/Loader";
import Validate from "./Validate";
import moment from "moment";
export default {
  data() {
    return {
      loader: false,
      transfer: false,
      otpcheck: false,
      type: "imps",
      otp: "",
      benifylist: [],
      bname: "",
      bmobile: "",
      baccount: "",
      bifsccode: "",
      bank: {},
      banklist: [],
      bbname: "",
      bbranch: "",
      currentb: {},
      amount: "",
      dmrmessage: "",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    security() {
      return this.$store.getters.security;
    },
    dmr() {
      return this.$store.getters.dmr;
    },
  },
  watch: {
    dmr(val) {
      this.fetchbank();
      this.fetchbenify();
    },
    amount() {
      this.dmrmessage = "";
    },
  },
  methods: {
    async submit() {
      let vm = this;
      if (vm.amount === "") return vm.notification("warn", "Amount Required");
      if (vm.user == null || !vm.user.phone)
        return vm.notification("error", "Login Required!");
      let item = vm.currentb;
      let Receipt_TxId = "pay2_"+moment().format("YYYYMMDDHHmmss")
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Sender_MobileNo: vm.dmr.mobile_no,
        Sender_Name: vm.dmr.name,
        Beneficiary_Name: item.beneficiary_name,
        Account_No: item.beneficiary_account_no,
        Amount: vm.amount,
        Transfer_Type: vm.type,
        Receipt_TxId,
        Bank_Name: item.beneficiary_bank_name,
        IFSC: item.ifsc_code,
        Security_Key: vm.security,
      };
      vm.loader = true;
      let list = vm.transList();
      let error = false;
      let totalamount = vm.amount;
      let total = 0;
      let message = "";
      for (var i = 0; i < list.length; i++) {
        try {
          doc.Amount = list[i];
          if (!error) {
            message += `Transfer amount : ${list[i]} </br>`;
            let res = await vm.sendMoney(doc);
            message += `Response : ${res}</br> </br>`;
            total += Number(list[i]);
          }
        } catch (e) {
          error = true;
          message += `Response : ${e} </br></br>`;
        }
      }
      message += `Total amount : ${totalamount} </br>`;
      message += `Transfered amount : ${total} </br>`;
      vm.loader = false;
      vm.amount = "";
      vm.dmrmessage = "";
      vm.transfer = false;
      vm.$root.alert(message);
    },
    sendMoney(doc) {
      const vm = this;
      return new Promise((resolve, reject) => {
        vm.$store
          .dispatch("axiosdmrpost", {
            url: "Money_Transfer",
            data: doc,
            type: "minkspay",
          })
          .then(function ({ data }) {
            resolve(data.Data);
          })
          .catch(function (error) {
            reject(error.message);
          });
      });
    },
    transList() {
      const vm = this;
      let list = [];
      let total = vm.amount;
      let limit = 5000;
      let closing = vm.balance;
      let doc = {
        MobileNo: vm.user.phone,
        PinNo: vm.user.pin,
        Amount: limit,
      };
      if (total > limit) {
        let reminder = total % limit;
        let subtotal = total - reminder;
        let count = subtotal / limit;
        for (var i = 0; i < count; i++) {
          list.push(limit);
        }
        if (reminder !== 0) {
          list.push(reminder);
        }
      } else {
        list.push(total);
      }
      return list;
    },
    dmrcharge() {
      let vm = this;
      if (vm.amount === "") return vm.notification("warn", "Amount Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Amount: vm.amount,
        Source: "json",
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiospost", {
          url: "DMTF_Charge",
          data: doc,
        })
        .then(function (res) {
          vm.loader = false;
          vm.dmrmessage = res.data.Message;
          console.log(res);
        })
        .catch(function (error) {
          vm.loader = false;
          vm.notification("error", error);
        });
    },
    fetchbank() {
      let vm = this;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        source: "json",
        Security_Key: vm.security,
      };
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Get_Bank_List",
          type: "minkspay",
          data: doc,
        })
        .then(function (res) {
          let { data } = vm.convert(res.data.Data);
          vm.banklist = data;
          console.log(data);
        })
        .catch(function (err) {
          vm.notification("error", err.message);
        });
    },
    addbeneficiary() {
      let vm = this;
      if (vm.bname === "")
        return vm.notification("warn", "Beneficiary Name Required");
      if (vm.bmobile === "")
        return vm.notification("warn", "Beneficiary Mobile Required");
      if (vm.bmobile.length !== 10)
        return vm.notification("warn", "Enter Valid Mobile");
      if (vm.baccount === "")
        return vm.notification("warn", "Beneficiary Account Required");
      if (vm.bifsccode === "")
        return vm.notification("warn", "Beneficiary IFSC Code Required");
      if (vm.bbname === "")
        return vm.notification("warn", "Beneficiary Bank Name Required");
      // if (vm.bbranch === "")
      //   return vm.notification("warn", "Beneficiary Branch Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
        Sender_MobileNo: vm.dmr.mobile_no,
        First_Name: vm.bname,
        Last_Name: "",
        Beneficiary_MobileNo: vm.bmobile,
        IFSC: vm.bifsccode,
        Account_No: vm.baccount,
        Bank_Id: vm.bbname,
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Add_Beneficiary",
          type: "minkspay",
          data: doc,
        })
        .then(function (res) {
          vm.fetchbenify();
          vm.loader = false;
          let data = res.data;
          vm.bname = "";
          vm.bmobile = "";
          vm.baccount = "";
          vm.bifsccode = "";
          vm.bbname = "";
          let { message } = vm.convert(data.Data);

          if (data.Status === "False") {
            vm.notification("error", message);
            return;
          }
          vm.notification("success", message);
        })
        .catch(function (err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    verifyotp() {
      let vm = this;
      if (vm.otp === "") return vm.notification("warn", " OTP Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
        Sender_MobileNo: vm.dmr.mobile_no,
        Beneficiary_Id: vm.currentb.BENEID,
        OTP: vm.otp,
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Delete_Beneficiary_VerifyOtp",
          data: doc,
        })
        .then(function (res) {
          vm.loader = false;
          let data = res.data;
          if (data.STATUS === "FAILED") {
            vm.notification("error", data.MESSAGE);
            return;
          }
          vm.otpcheck = false;
          vm.notification("success", data.MESSAGE);
          vm.otp = "";
          vm.fetchbenify();
        })
        .catch(function (err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    convert(str) {
      let json = {};
      try {
        json = JSON.parse(str);
      } catch (e) {}
      return json;
    },

    fetchbenify() {
      let vm = this;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
        Sender_MobileNo: vm.dmr.mobile_no,
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Sender_Validate",
          data: doc,
          type: "minkspay",
        })
        .then(function (res) {
          vm.loader = false;
          let { data } = vm.convert(res.data.Data);
          console.log(data);
          vm.benifylist = data.beneficiary;
        })
        .catch(function (err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    remove(item) {
      let vm = this;
      vm.currentb = item;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
        Sender_MobileNo: vm.dmr.mobile_no,
        Account_No: item.beneficiary_account_no,
        Security_Key: vm.security,
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Delete_Beneficiary",
          data: doc,
          type: "minkspay",
        })
        .then(function (res) {
          vm.loader = false;
          let data = res.data;
          let { message } = vm.convert(data.Data);
          vm.fetchbenify();
          vm.notification("success", message);
        })
        .catch(function (err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },

    validate(item) {
      let vm = this;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Sender_MobileNo: vm.dmr.mobile_no,
        Sender_Name: vm.dmr.name,
        First_Name: item.beneficiary_name,
        Last_Name: "",
        Beneficiary_MobileNo: item.beneficiary_mobile_no,
        Beneficiary_Name: item.beneficiary_name,
        Bank_Name: item.beneficiary_bank_name,
        IFSC: item.ifsc_code,
        Bank_Id: item.beneficiary_bank_id,
        Account_No: item.beneficiary_account_no,
        Security_Key: vm.security,
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Verify_Beneficiary",
          type: "minkspay",
          data: doc,
        })
        .then(function (res) {
          vm.loader = false;
          let data = res.data;
          let { message } = vm.convert(data.Data);
          if (data.Status === "False") {
            vm.$root.alert(data.Data);
            return;
          }
          vm.fetchbenify();
          vm.$root.alert(data.Data);
        })
        .catch(function (err) {
          vm.loader = false;
          vm.$roor.alert(err.message);
        });
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type,
      });
    },
  },
  mounted() {
    this.fetchbank();
  },
  components: { Loader, Validate },
};
</script>
